module.exports = __webpack_public_path__ + "static/SectionFourBackground.bbb6f599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pngs/SectionFourBackground.png
// module id = 498
// module chunks = 35783957827783